/**
 * The status label for a document marked Final, with its override count.
 *
 * "Final" for a plain Final document, "Final, with N failed checks overridden"
 * when an administrator overrode failing checks and N of them still fail.
 * Returns null when the document is not Final, so a caller keeps its own label
 * for Draft and the rest. Pure: no React, no Firestore. The override is stored
 * server-side only (artifact.override); a screen reads it, never writes it.
 */
export function finalStatusLabel(
  status: string | null | undefined,
  override: { checks?: readonly unknown[]; count?: number } | null | undefined,
): string | null {
  if (status !== 'approved' && status !== 'final') return null;
  const n = Array.isArray(override?.checks)
    ? override!.checks!.length
    : typeof override?.count === 'number'
      ? override.count
      : 0;
  if (!(n > 0)) return 'Final';
  return `Final, with ${n} failed ${n === 1 ? 'check' : 'checks'} overridden`;
}
